import { type ChangeEvent } from "react";
import { DropzoneOptions } from "react-dropzone";

import { theme } from "@/src/theme/theme";

import { DROPZONE_ACCEPT_CONFIG } from "@/src/config/baanaConfig";

export const REQUIRED_MARK_STYLE = {
  position: "absolute",
  top: 12,
  left: 16,
  color: theme.palette.semantic.error.main,
  fontSize: { xs: "1.25rem", sm: "1.5rem" },
  zIndex: 2,
  fontWeight: theme.typography.fontWeightSemibold
};

export const DROPZONE_IMAGE_BOX_STYLE = {
  minHeight: { xs: "130px", sm: "150px" },
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "20px",
  width: "100%",
  maxWidth: "600px",
  mx: "auto",
  p: { xs: 2, sm: 2.5 },
  boxShadow: theme.shadows[4],
  position: "relative",
  overflow: "hidden",
  transition: "all 0.2s ease-in-out"
};

export const DROPZONE_STYLE = {
  border: "2px dashed transparent",
  borderRadius: "20px",
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    borderColor: theme.palette.semantic.primary.main,
    backgroundColor: theme.palette.background.paper
  },
  "&.dropzone-active": {
    borderColor: theme.palette.semantic.primary.main,
    backgroundColor: theme.palette.semantic.primary.selected
  }
};

export const LOADING_OVERLAY_STYLE = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "20px",
  background: theme.palette.text.secondary,
  zIndex: 3,
  pointerEvents: "none"
};

export const convertFilesToFileList = (acceptedFiles: File[]): FileList => {
  if (typeof window !== "undefined" && "DataTransfer" in window) {
    const dt = new DataTransfer();
    acceptedFiles.forEach((f) => dt.items.add(f));
    return dt.files;
  }
  const files = [...acceptedFiles];
  return Object.assign(files, {
    item: (index: number) => files[index] ?? null,
    length: files.length
  }) as FileList;
};

export const getDropzoneConfig = (
  onDrop: (files: File[]) => void,
  disabled: boolean,
  options?: Partial<DropzoneOptions>
) => ({
  onDrop,
  accept: DROPZONE_ACCEPT_CONFIG,
  multiple: true,
  disabled,
  noClick: false,
  noKeyboard: false,
  ...options
});

export const createSyntheticFileEvent = (
  fileList: FileList
): ChangeEvent<HTMLInputElement> =>
  ({
    target: {
      files: fileList
    }
  }) as ChangeEvent<HTMLInputElement>;
